import * as React from 'react'

import { BuildYourOwnBundleReturnType } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/ResponsiveBuildYourOwnBundleResolver'
import { BuildYourOwnBundle } from '@thg-commerce/widget-build-your-own-bundle'

import { BaseWidgetProps } from '../types'

export type BuildYourOwnBundleRendererProps = BaseWidgetProps & {
  responsiveBuildYourOwnBundle: BuildYourOwnBundleReturnType
}

export const BuildYourOwnBundleRenderer = (
  props: BuildYourOwnBundleRendererProps,
) => {
  if (!props.responsiveBuildYourOwnBundle) {
    return null
  }
  return <BuildYourOwnBundle {...props.responsiveBuildYourOwnBundle} />
}
